import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import {
  Speed,
  Security,
  TrendingUp,
  Support,
  AccountBalance,
  CheckCircle,
} from "@mui/icons-material";

const features = [
  {
    icon: <Speed />,
    title: "Fast Approval",
    description:
      "Get your loan approved within hours. Quick processing with minimal paperwork.",
  },
  {
    icon: <Security />,
    title: "Secure & Safe",
    description:
      "Your information is protected with bank-level security encryption.",
  },
  {
    icon: <TrendingUp />,
    title: "Flexible Terms",
    description:
      "Choose repayment terms that suit your budget, from 1 to 30 days.",
  },
  {
    icon: <Support />,
    title: "24/7 Support",
    description: "Our customer service team is always available to help you.",
  },
  {
    icon: <AccountBalance />,
    title: "Transparent Rates",
    description:
      "No hidden fees. Clear and upfront about all costs and charges.",
  },
  {
    icon: <CheckCircle />,
    title: "Easy Application",
    description:
      "Simple online application process that takes minutes to complete.",
  },
];

const Features = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h2"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: "primary.main",
            }}
          >
            Why Choose Us
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ maxWidth: "700px", mx: "auto" }}
          >
            We provide fast, secure, and flexible cash loans with transparent
            rates and exceptional customer service.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: "center", p: 3 }}>
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      bgcolor: "primary.main",
                      color: "white",
                      mb: 2,
                      "& svg": {
                        fontSize: 40,
                      },
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Features;
